import React, { forwardRef } from 'react';
import { Box } from '@mui/material';

/** 
 * BackgroundBox component uses forwardRef to allow ref forwarding 
 */
export const BackgroundBox = forwardRef((props, ref) => {
  /** Forward the ref to the Box component */
  return (
    <Box
      ref={ref}
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '70%',
        height: '90%',
        bgcolor: 'background.default',
        borderRadius: '8px',
        boxShadow: 24,
        p: 4,
        overflowY: 'auto'
      }}
    >
      {props.children}
    </Box>
  );
});
